import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 要设置全局访问的state对象
    // 要设置的初始属性值
    users: [{ mame: '张三' }]
  },
  getters: {
    // 实时监听state值的变化(最新状态)
    getCommentList(state) {
      return state.commentList
    },
    getUsers(state) {
      return state.users
    }
  },
  mutations: {
    add(state, data) {
      state.users.push(data)
    },
    push(state, data) {
      state.commentList.push(data)
    }
  },
  actions: {
    addList({ commit }, data) {
      commit('push', data)
    },
    addUser({ commit }, data) {
      commit('add', data)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js